/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/forms';
import * as import2 from '../../../app/server/server-alerts.component';
const styles_ServerAlertsComponent:any[] = ([] as any[]);
export const RenderType_ServerAlertsComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ServerAlertsComponent,
  data: {}
}
);
export function View_ServerAlertsComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks blocks-centered'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Serwer: serv.nazw.023.test'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[
      [
        'class',
        'btn btn-medium'
      ]
      ,
      [
        'href',
        '#'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zgłoś awarię'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wróć do monitoring'])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),43,'header',[[
        'class',
        'blocks header dashed'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'class',
        'section-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Monitoring:'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),34,'div',[[
        'class',
        'options blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'small-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Okres monitorowania:\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),22,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),19,'label',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),16,'select',[[
        'class',
        'little short'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'option',[
      [
        'selected',
        ''
      ]
      ,
      [
        'value',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import1.NgSelectOption,[
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    import0.ɵdid(147456,(null as any),0,import1.ɵq,[
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['Ostatnie 24h'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'option',[[
        'value',
        '1'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import1.NgSelectOption,[
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    import0.ɵdid(147456,(null as any),0,import1.ɵq,[
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['Option 1'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'option',[[
        'value',
        '2'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import1.NgSelectOption,[
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    import0.ɵdid(147456,(null as any),0,import1.ɵq,[
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['Option 2'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zmień'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),385,'div',[[
        'class',
        'row-large'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'icon icon-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Powstrzymany atak DDoS, godz. 01:24, 21.01.2017\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        '#'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Raport'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_0:any = '';
    ck(v,39,0,currVal_0);
    const currVal_1:any = '';
    ck(v,40,0,currVal_1);
    const currVal_2:any = '1';
    ck(v,44,0,currVal_2);
    const currVal_3:any = '1';
    ck(v,45,0,currVal_3);
    const currVal_4:any = '2';
    ck(v,49,0,currVal_4);
    const currVal_5:any = '2';
    ck(v,50,0,currVal_5);
  },(null as any));
}
function View_ServerAlertsComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-server-alerts',([] as any[]),(null as any),(null as any),(null as any),View_ServerAlertsComponent_0,RenderType_ServerAlertsComponent)),
    import0.ɵdid(114688,(null as any),0,import2.ServerAlertsComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ServerAlertsComponentNgFactory:import0.ComponentFactory<import2.ServerAlertsComponent> = import0.ɵccf('app-server-alerts',import2.ServerAlertsComponent,View_ServerAlertsComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/server/server-alerts.component.ngfactory.ts